module.exports = __webpack_public_path__ + "img/training.e4efe346.svg";